module.exports = __webpack_public_path__ + "img/Support-skill-433.7c658496.png";